import React from 'react'
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography'
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'

import LinkedProducts from './linked'
import { Box } from '@mui/material';

const putData = data => data.map(p => p.id)
const foundCondition = (product, query) => {
    return product.sku.indexOf(query) >= 0 ||
    product.asin.indexOf(query) >= 0 ||
    product.name.indexOf(query) >= 0
}

const InventoryProducts = ({onChange, data, currentValue, key, ...rest}) => {
    const [query, setQuery] = React.useState(null)
    const [visible, setVisible] = React.useState(putData(data))
    const [selectedProducts, setSelectedProduct] = React.useState(currentValue || [])
    const [open, setOpen] = React.useState(false)
    const onSelect = (pid) => {
        selectedProducts.includes(pid)?
            setSelectedProduct(selectedProducts.filter(p => p != pid)):
            setSelectedProduct([...selectedProducts, pid])
    }
    const select = () => {
        onChange({name: key, value: selectedProducts})
        setOpen(false)
    }
    React.useEffect(() => {
        if(query != null){
            if(query == '')
                setVisible(putData(data))
            else
                setVisible(putData(data.filter((p) => foundCondition(p ,query))))
        }
    }, [query])

    return (
        <React.Fragment>
            <Button onClick={() => setOpen(true)}>{selectedProducts.length == 1? `${selectedProducts.length} producto ligado`: `${selectedProducts.length} productos ligados`}</Button>
            <Dialog onClose={() => setOpen(false)} open={open}>
                <Box sx={{display: 'flex', justifyContent:'flex-start', flexDirection:'row'}}>
                    <DialogTitle>Seleccione los productos a ligar</DialogTitle>
                    <FormControl sx={{ m: 1, width: '25ch' }}>
                        <TextField multiline variant="outlined" 
                            label="Buscar"
                            name="query"
                            value={query}
                            onChange={(e) => setQuery((e.target || e.currentTarget).value)}
                        />
                    </FormControl>
                </Box>
                <LinkedProducts products={data} visible={visible} selected={selectedProducts} onSelect={onSelect} />
                <Button onClick={select}>Ligar</Button>
            </Dialog>
        </React.Fragment>
    )
}

export default  InventoryProducts